import { APP_INITIALIZER, inject } from '@angular/core';
import { APPLICATION_CONFIGURATION_SERVICE, BaseConfigService } from '@lx/shared/app-config';
import { coreEnvironment, environment } from '../../environments/environment';
import { SharedDataStore } from '../store';
import { firstValueFrom } from 'rxjs';
import { configFactory } from '@lx/shared/app-init';
import { getCompanyHeader } from '@lx/shared/tokens';
import { NGXLogger } from 'ngx-logger';
import { loggingFactory } from '@lx/shared/app-init/functions/logging.factory';

export const getAppInitializers = () => {
  return [
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const configService = inject(APPLICATION_CONFIGURATION_SERVICE);
        const loggingService = inject(NGXLogger);
        const companyHeader = getCompanyHeader();
        return loggingFactory(configService, loggingService, companyHeader, coreEnvironment);
      },
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: (configService: BaseConfigService) => configFactory(environment, configService),
      deps: [APPLICATION_CONFIGURATION_SERVICE],
      multi: true,
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => {
        const store = inject(SharedDataStore);
        return () => firstValueFrom(store.loadSharedData());
      },
      multi: true,
    },
  ];
};
